import { translationService } from './translationEnhancementService';

export const enhancePrompt = async (currentPromptTurkish = '', style = '', mode = 'interior') => {
  try {
    const result = await translationService.translateAndEnhance(currentPromptTurkish, 'TR_TO_EN', {
      enhance: true,
      style,
      mode
    });
    
    return result.enhancedText || result.translatedText;
  } catch (error) {
    console.error("Prompt enhancement error:", error);
    throw new Error("Failed to enhance prompt");
  }
};
